module.exports = __webpack_public_path__ + "static/media/Flock.02023d63.png";